import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { NgxPageScrollModule } from 'ngx-page-scroll';

import { SharedModule } from 'shared/shared.module';
import { DigitalAssetDetailsComponent } from './digital-asset-details.component';
import { DigitalAssetDetailsRoutingModule } from './digital-asset-details-routing.module';
import { DigitalAssetDetailsService } from './digital-asset-details.service';
import { HintsTabComponent } from './components/hints-tab/hints-tab.component';

import { BaseSegmentComponent } from './components/base/_base-segment.component';

import { DigitalAssetsPanelModule } from '../digital-assets-panel/digital-assets-panel.module';

// segments
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';
import { AssignedComponent } from './components/assigned/assigned.component';
import { AssignedSearchService } from './components/assigned/assigned-search.service';
import { MarketcopyAssignedSearchService } from './components/assigned/marketcopy-assigned-search.service';
import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { LogsService } from 'shared/logs/logs.service';
import {NgxPageScrollCoreModule} from 'ngx-page-scroll-core';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DigitalAssetDetailsRoutingModule,
        SharedModule,
        DigitalAssetsPanelModule,
        NgxPageScrollCoreModule.forRoot({}),
        NgxPageScrollModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        DigitalAssetDetailsComponent,
        HintsTabComponent,
        AssetDetailsComponent,
        AssignedComponent,
        BaseSegmentComponent,
    ],
    exports: [],
    providers: [
        DigitalAssetDetailsService,
        SegmentValidationService,
        LogsService,
        AssignedSearchService,
        MarketcopyAssignedSearchService,
    ]
})
export class DigitalAssetDetailsModule {}
